import {
  FETCH_SECTIONS,
  FETCH_SECTIONS_SUCCESS,
  FETCH_SECTIONS_FAIL,
  FETCH_SECTION_TASKS,
  FETCH_SECTION_TASKS_SUCCESS,
  FETCH_SECTION_TASKS_FAIL,
  UPDATE_TASK_STATUS,
  UPDATE_TASK_STATUS_SUCCESS,
  UPDATE_TASK_STATUS_FAIL,
  CLEAR_SECTIONS_CACHE,
  SET_ACTIVE_SECTION,
} from "./actionTypes"

// Fetch Sections
export const fetchSections = (forceRefresh = false) => ({
  type: FETCH_SECTIONS,
  payload: { forceRefresh },
})

export const fetchSectionsSuccess = (sections) => ({
  type: FETCH_SECTIONS_SUCCESS,
  payload: sections,
})

export const fetchSectionsFail = (error) => ({
  type: FETCH_SECTIONS_FAIL,
  payload: error,
})

// Fetch Section Tasks
export const fetchSectionTasks = (forceRefresh = false) => ({
  type: FETCH_SECTION_TASKS,
  payload: { forceRefresh },
})

export const fetchSectionTasksSuccess = (tasks) => ({
  type: FETCH_SECTION_TASKS_SUCCESS,
  payload: tasks,
})

export const fetchSectionTasksFail = (error) => ({
  type: FETCH_SECTION_TASKS_FAIL,
  payload: error,
})

// Update Task Status
export const updateTaskStatus = (taskId, status, extraData = {}) => ({
  type: UPDATE_TASK_STATUS,
  payload: { taskId, status, extraData },
})

export const updateTaskStatusSuccess = (task) => ({
  type: UPDATE_TASK_STATUS_SUCCESS,
  payload: task,
})

export const updateTaskStatusFail = (error) => ({
  type: UPDATE_TASK_STATUS_FAIL,
  payload: error,
})

// Clear cache
export const clearSectionsCache = () => ({
  type: CLEAR_SECTIONS_CACHE,
})

// Set active section
export const setActiveSection = (sectionName) => ({
  type: SET_ACTIVE_SECTION,
  payload: sectionName,
})
